import React, { useState, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import ReviewData from "../Components/ReviewData";
import { useSelector } from "react-redux";
import { selectSleeveDataStageOne } from "../../../Redux/Reducers/selectors";
import {
  getReviewDataDialogWidth,
  getReviewDataDialogPaperSx,
} from "../styles/rebalancerStyles";

const ReviewDataDialogue = ({ title, open, onClose }) => {
  const [existingNewArray, setExistingNewArray] = useState({});
  const sleeveDataStageOne = useSelector(selectSleeveDataStageOne);

  const tableCount = Object.keys(sleeveDataStageOne ?? {}).length;

  const dialogWidth = useMemo(
    () => getReviewDataDialogWidth(tableCount),
    [tableCount, open]
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={getReviewDataDialogPaperSx(dialogWidth)}
    >
      <DialogTitle
        sx={{
          flexShrink: 0,
          py: 1.5,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontSize: "20px" }}>
            {title}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          flex: "0 1 auto",
          overflow: "auto",
          py: 2,
          px: 2,
        }}
      >
        <ReviewData
          sleeve={true}
          setExistingNewArray={setExistingNewArray}
          existingNewArray={existingNewArray}
          sleeveDataStageOne={sleeveDataStageOne}
          showNext={false}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ReviewDataDialogue;
